import { Component, OnInit, inject } from '@angular/core';
import { ForumService } from 'src/app/forum/forum.service';
import { WebForum } from 'src/app/forum/web-forum';

@Component({
  selector: 'app-home-user',
  templateUrl: './home-user.component.html',
  styleUrls: ['./home-user.component.scss'],
  standalone: false
})
export class HomeUserComponent implements OnInit {
  private forumService = inject(ForumService);

  forums: WebForum[] = [];
  isLoading = true;

  ngOnInit(): void {
    this.forumService.getForums().subscribe((forums) => {
      this.forums = forums;
      this.isLoading = false;
    });
  }

  get yourForums() {
    return this.forums.filter((forum) => forum.canParticipate);
  }

  get exploreForums() {
    return this.forums.filter((forum) => !forum.canParticipate);
  }
}
